import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { HistoryManager } from "../../Managers/HistoryManager";
import { CarouselConfig } from "../../carousel/config";
import { LibraryThing } from "../widget/LibraryThingWidget";
import { BaseView } from "./BaseView";

export class LandingPageView extends BaseView {

  constructor(targetId) {
    super({
      targetId,
      id: LS2PAC_CONSTANTS.Ids.landingPage,
    });
  }
  addListeners() {}
  addHistory(event) {}
  load(event) {}
  render(event) {
    var _this = this;
    CarouselConfig.init({
      isDebugEnabled:
        window.location.href.indexOf("debug") != -1 ? true : false,
      baseUrl: "",
      target: "#" + this.id,
      customIsActiveView: function () {
        return _this.isActive;
      },
      getCarouselImageUrl: function (resource) {
        var jacketSize = LibraryThing.enums.requestType.bookJacketLarge;
        return LibraryThing.getBookjacketUrl(jacketSize, resource);
      },
    });
  }
  cleanup(){
    CarouselConfig.destroy();
    super.cleanup();

  }
}
